<template>
    <div class="resume">
        <div class="main">
            <div>
                <h3>{{Jobtitle}}<span @click="goback"> ( 返回职位详情 ) </span></h3>
                <information @fatherMethod="fatherMethod"
                             @fatherdisplay="fatherdisplay"
                             v-on:informationByValue="informationByValue"
                             ref="information" />
                <JobStatus v-on:JobStatusByValue="JobStatusByValue"
                           ref="JobStatus" />
                <experience v-on:experienceByValue="experienceByValue"
                            ref="experience" />
                <educationExperience v-show="educational"
                                     v-on:educationExperienceValue="educationExperienceValue"
                                     ref="educationExperience" />
                <projectExperience v-on:projectExperienceByValue="projectExperienceByValue"
                                   ref="projectExperience" />
                <selfEvaluation v-on:selfEvaluationByValue="selfEvaluationByValue"
                                ref="selfEvaluation" />

                <div class="captcha">
                    <el-form style="margin-left:30px"
                             :model="ruleForm"
                             :rules="rules"
                             ref="ruleForm"
                             :inline="true"
                             label-position="top"
                             label-width="100px">
                        <el-form-item label="验证码"
                                      prop="captcha">
                            <el-input style="width:120px;position: relative;top: -14px;"
                                      placeholder="验证码"
                                      maxlength="4"
                                      v-model="ruleForm.captcha"></el-input><img style="height: 38px;width: 100px;"
                                 @click="changeimage"
                                 :src="image">
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn">
                <el-button type="primary"
                           @click="handleSubmit('ruleForm')">投递简历</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import Bus from "@/utils/bus";
import information from "@/views/onlineResume/information";
import JobStatus from "@/views/onlineResume/JobStatus";
import experience from "@/views/onlineResume/experience";
import educationExperience from "@/views/onlineResume/educationExperience";
import selfEvaluation from "@/views/onlineResume/selfEvaluation";
import projectExperience from "@/views/onlineResume/projectExperience";
import { saveresume } from "@/api/homePage";
import { selectbasicinfo } from "@/api/apiall";
import { debuglog } from "util";
var i = 1;
// import { captcha } from "@/api/apiall";
export default {
    components: {
        information,
        JobStatus,
        experience,
        educationExperience,
        projectExperience,
        selfEvaluation
    },
    data() {
        return {
            rules: {
                captcha: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[0-9]{4}$/,
                        message: "请输入正确格式",
                        trigger: "blur"
                    }
                ]
            },
            ruleForm: {
                captcha: ""
            },
            // captcha: "",
            image: "",
            educational: true,
            centerDialogVisible: false,
            Jobtitle: "",
            data: {
                id: "",
                userId: "",
                captcha: "",
                workList: [],
                educateList: [],
                projectList: []
            },
            positionid: { post: "" },
            information: {},
            selfEvalua: {},
            JobStatus: {},
            workList: [],
            educateList: [],
            projectList: []
        };
    },
    created() {
        this.Jobtitle = this.$route.query.name;
        this.positionid.post = this.$route.query.zwid;
        this.searchcaptcha();
        if (sessionStorage.getItem("userId") != "undefined") {
            debugger;
            this.search();
        }
    },
    methods: {
        search() {
            return new Promise(async resolve => {
                this.ruleForm.userId = sessionStorage.getItem("userId");
                await selectbasicinfo({ userId: this.ruleForm.userId }).then(
                    res => {
                        if (res.status === 2000) {
                            if (res.data) {
                                resolve(res.data);
                                sessionStorage.setItem(
                                    "informationId",
                                    res.data.personId
                                );
                            }
                        }
                    }
                );
                this.$refs.JobStatus.searchJobStatus();
                this.$refs.experience.searchselectworkexperience();
                this.$refs.educationExperience.searchselecteducateexperience();
                this.$refs.projectExperience.searchselectprojectexperience();
                this.$refs.selfEvaluation.searchselectevaluation();
            });
        },
        changeimage() {
            this.image =
                process.env.VUE_APP_API + "/nologinsystem/captcha?" + i++;
        },
        searchcaptcha() {
            this.image =
                process.env.VUE_APP_API + "/nologinsystem/captcha?" + i++;
            // captcha()
            //     .then(res => {
            //         this.image = res.data;
            //     })
            //     .catch(err => {});
        },
        fatherMethod() {
            this.educational = false;
            // this.$refs.educationExperience.showedchange();
        },
        fatherdisplay() {
            this.educational = true;
            // this.$refs.educationExperience.showedchangedisplay();
        },
        handleSubmit(ruleForm) {
            debugger;
            this.$refs.information.handleSubmit(ruleForm);
            this.$refs.JobStatus.handleSubmit(ruleForm);
            this.$refs.experience.save(ruleForm);
            this.$refs.educationExperience.save(ruleForm);
            this.$refs.projectExperience.save();
            this.$refs.selfEvaluation.save();
            this.data = Object.assign(
                this.positionid,
                this.information,
                this.JobStatus,
                this.selfEvalua
            );
            this.data.workList = this.workList;
            this.data.educateList = this.educateList;
            this.data.projectList = this.projectList;
            if (this.educational == true) {
                this.$refs[ruleForm].validate(valid => {
                    if (
                        valid &&
                        this.information.name &&
                        this.JobStatus.areaId &&
                        this.data.workList.length !== 0 &&
                        this.data.educateList.length !== 0
                    ) {
                        this.savamain();
                    } else {
                        if (!valid) {
                            this.$message({
                                message: "验证码必填",
                                type: "warning"
                            });
                            this.data = {};
                        } else {
                            this.$message({
                                message: "请输入必填信息",
                                type: "warning"
                            });
                            this.data = {};
                        }
                    }
                });
            } else {
                this.$refs[ruleForm].validate(valid => {
                    if (
                        valid &&
                        this.information.name &&
                        this.JobStatus.areaId &&
                        this.data.workList.length !== 0
                    ) {
                        this.savamain();
                    } else {
                        if (!valid) {
                            this.$message({
                                message: "验证码必填",
                                type: "warning"
                            });
                            this.data = {};
                        } else {
                            this.$message({
                                message: "请输入必填信息",
                                type: "warning"
                            });
                            this.data = {};
                        }
                    }
                });
            }
        },
        savamain() {
            if (sessionStorage.getItem("userId") != "undefined") {
                this.data.userId = sessionStorage.getItem("userId");
                 this.data.id = sessionStorage.getItem("informationId");
            } else {
                this.data.userId = "";
                 this.data.id = "";
            }

            this.data.captcha = this.ruleForm.captcha;
            this.centerDialogVisible = false;
            saveresume(this.data).then(res => {
                if (res.status === 2000) {
                    this.$message({
                        message: "恭喜你，投递成功",
                        type: "success"
                    });
                    this.$router.go(-1);
                } else if (res.status === 4102) {
                    this.$message({
                        message: res.data[0].errorMsg,
                        type: "warning"
                    });
                } else if (res.status === 5100) {
                    this.$message({
                        message: res.data,
                        type: "warning"
                    });
                    this.changeimage();
                } else {
                    this.$message({
                        message: "投递失败",
                        type: "warning"
                    });
                }
            });
        },
        informationByValue(childValue) {
            this.information = childValue;
        },
        JobStatusByValue(childValuel) {
            this.JobStatus = childValuel;
        },
        experienceByValue(childValuel) {
            this.workList = childValuel;
        },
        educationExperienceValue(childValuel) {
            this.educateList = childValuel;
        },
        projectExperienceByValue(childValuel) {
            this.projectList = childValuel;
        },
        selfEvaluationByValue(childValuel) {
            this.selfEvalua = childValuel;
        },
        goback() {
            this.$router.go(-1);
        }
    }
};
</script>


<style scoped lang="scss">
.resume {
    width: 100%;
    padding-top: 30px;
    background-color: #f5f6f7;
    .main {
        position: relative;
        overflow: hidden;
        width: 1200px;
        // background-color: #fff;
        margin: 0 auto;
        padding-bottom: 60px;
        h3 {
            width: 870px;
            padding-left: 30px;
            padding-top: 20px;
            background-color: #fff;
            // padding-bottom: 20px;
            span {
                margin-left: 20px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
            }
            span:hover {
                color: #fabe00;
            }
        }
        .captcha {
            width: 900px;
            float: left;
            background-color: #fff;
            padding-bottom: 30px;
            p {
                margin-left: 30px;
                font-size: 18px;
                margin-top: 20px;
            }
            .el-input {
                border-radius: none;
            }
            .changeimage {
                width: 100px;
                height: 40px;
                position: relative;
                top: 15px;
            }
        }
        .btn {
            // margin-left: 50px;
            .el-input {
                border-radius: none;
            }
            .el-button {
                position: fixed;
                top: 200px;
                margin-left: 60px;
            }
            .changeimage {
                width: 100px;
                height: 40px;
                position: relative;
                top: 15px;
            }
        }
    }
}
</style>
